import { useCallback } from 'react';
import { useToast } from './useToast.js';

/* ══════════════════════════════════════════
   Feedback melden
   ──────────────────────────────────────────
   Der Knopf soll das Mailprogramm öffnen. Vorher stand hier

     window.open(FEEDBACK_URL, '_blank', 'noopener')

   und das ist für mailto: der falsche Griff: Browser behandeln open() als
   Popup. Entweder blocken sie es, oder sie öffnen einen leeren Reiter, der
   sich sofort wieder schließt — beim Nutzer passierte gar nichts. Ein
   mailto: gehört an location.href; das ist kein Popup und wird nicht
   geblockt.

   Ob ein Mailprogramm eingerichtet ist, kann man nicht abfragen. Gibt es
   keines, passiert bei einem mailto: einfach nichts — ohne Fehler. Deshalb
   die einzige verfügbare Auskunft: verliert das Fenster den Fokus, hat
   etwas übernommen. Bleibt es vorn, hat nichts übernommen, und dann landet
   die Adresse in der Zwischenablage samt Hinweis.

   Die Wartezeit ist ein Kompromiss. Zu kurz, und ein langsam startendes
   Mailprogramm wird für „nichts passiert" gehalten; zu lang, und der Nutzer
   wartet auf eine Rückmeldung, die nie kommt. Wer in dem Moment aus
   anderen Gründen das Fenster wechselt, bekommt keinen Toast — das ist der
   Preis und er ist verkraftbar.

   Adresse und Betreff stehen hier EINMAL. Vorher standen sie in SideNav.js
   und LoginPage.js getrennt.
   ══════════════════════════════════════════ */

export const FEEDBACK_ADRESSE = 'admin@dpsg-limburg.de';
const BETREFF = 'Dashboard Feedback / Problem';
const WARTEZEIT_MS = 900;

export function feedbackMailto() {
  return `mailto:${FEEDBACK_ADRESSE}?subject=${encodeURIComponent(BETREFF)}`;
}

export function useFeedback() {
  const { show } = useToast();

  return useCallback(async () => {
    let uebernommen = false;
    const merken = () => { uebernommen = true; };
    window.addEventListener('blur', merken, { once: true });
    document.addEventListener('visibilitychange', merken, { once: true });

    try {
      window.location.href = feedbackMailto();
    } catch { /* nichts zu retten, der Rückfall greift */ }

    await new Promise(r => setTimeout(r, WARTEZEIT_MS));
    window.removeEventListener('blur', merken);
    document.removeEventListener('visibilitychange', merken);

    if (uebernommen) return 'mailprogramm';

    /* Kein Mailprogramm. Die Zwischenablage braucht eine sichere Verbindung
       und eine Nutzergeste — der Klick zählt als Geste und hält länger als
       unsere Wartezeit. Wenn sie trotzdem verweigert, nennen wir die Adresse
       im Toast, damit sie wenigstens ablesbar ist. */
    try {
      await navigator.clipboard.writeText(FEEDBACK_ADRESSE);
      show(`Adresse kopiert: ${FEEDBACK_ADRESSE}`, 'success');
      return 'kopiert';
    } catch {
      show(`Kein Mailprogramm gefunden. Bitte an ${FEEDBACK_ADRESSE} schreiben.`, 'warning', 6000);
      return 'nur-angezeigt';
    }
  }, [show]);
}

export default useFeedback;
